/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import {
  PhoneCustomerSettingsResponseOutput,
  PhoneProgressResponseOutput,
  PhonePromptAssetMetadataResponseOutput,
  PhoneTeamNumberResponseOutput,
  PhoneTeamSettingsResponseOutput,
} from '../model';
import type {
  IncidentErrorResponse,
  PhoneCustomerSettingsBody,
  PhoneErrorResponse,
  PhoneTeamSettingsBody,
  UploadPhonePromptAssetParams,
} from '../model';

import { validatedIncidentFetch } from '../../incidents.transport';
import { validatedPhoneConfigurationFetch } from '../../phoneConfiguration.transport';
import { validatedPhonePromptPreviewFetch } from '../../phoneConfiguration.transport';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetIncidentPhoneUrl = (incidentId: string) => {
  return `/api/v1/incidents/${incidentId}/phone`;
};

export const getIncidentPhone = async (
  incidentId: string,
  options?: Parameters<typeof validatedIncidentFetch>[1],
): Promise<PhoneProgressResponseOutput> => {
  return validatedIncidentFetch<PhoneProgressResponseOutput>(getGetIncidentPhoneUrl(incidentId), {
    ...options,
    method: 'GET',

    schema: PhoneProgressResponseOutput,
  });
};

export const getGetIncidentPhoneQueryKey = (incidentId: string) => {
  return [`/api/v1/incidents/${incidentId}/phone`] as const;
};

export const getGetIncidentPhoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getIncidentPhone>>,
  TError = IncidentErrorResponse,
>(
  incidentId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getIncidentPhone>>, TError, TData>;
    request?: SecondParameter<typeof validatedIncidentFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIncidentPhoneQueryKey(incidentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIncidentPhone>>> = ({ signal }) =>
    getIncidentPhone(incidentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: incidentId !== null && incidentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getIncidentPhone>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetIncidentPhoneQueryResult = NonNullable<Awaited<ReturnType<typeof getIncidentPhone>>>;
export type GetIncidentPhoneQueryError = IncidentErrorResponse;

export function useGetIncidentPhone<
  TData = Awaited<ReturnType<typeof getIncidentPhone>>,
  TError = IncidentErrorResponse,
>(
  incidentId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getIncidentPhone>>, TError, TData>;
    request?: SecondParameter<typeof validatedIncidentFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetIncidentPhoneQueryOptions(incidentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTeamPhoneSettingsUrl = (teamId: string) => {
  return `/api/v1/teams/${teamId}/phone-settings`;
};

export const getTeamPhoneSettings = async (
  teamId: string,
  options?: Parameters<typeof validatedPhoneConfigurationFetch>[1],
): Promise<PhoneTeamSettingsResponseOutput> => {
  return validatedPhoneConfigurationFetch<PhoneTeamSettingsResponseOutput>(
    getGetTeamPhoneSettingsUrl(teamId),
    {
      ...options,
      method: 'GET',

      schema: PhoneTeamSettingsResponseOutput,
    },
  );
};

export const getGetTeamPhoneSettingsQueryKey = (teamId: string) => {
  return [`/api/v1/teams/${teamId}/phone-settings`] as const;
};

export const getGetTeamPhoneSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamPhoneSettings>>,
  TError = PhoneErrorResponse,
>(
  teamId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTeamPhoneSettings>>, TError, TData>;
    request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamPhoneSettingsQueryKey(teamId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamPhoneSettings>>> = ({ signal }) =>
    getTeamPhoneSettings(teamId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: teamId !== null && teamId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTeamPhoneSettings>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetTeamPhoneSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamPhoneSettings>>
>;
export type GetTeamPhoneSettingsQueryError = PhoneErrorResponse;

export function useGetTeamPhoneSettings<
  TData = Awaited<ReturnType<typeof getTeamPhoneSettings>>,
  TError = PhoneErrorResponse,
>(
  teamId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTeamPhoneSettings>>, TError, TData>;
    request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTeamPhoneSettingsQueryOptions(teamId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSaveTeamPhoneSettingsUrl = (teamId: string) => {
  return `/api/v1/teams/${teamId}/phone-settings`;
};

export const saveTeamPhoneSettings = async (
  teamId: string,
  phoneTeamSettingsBody: PhoneTeamSettingsBody,
  options?: Parameters<typeof validatedPhoneConfigurationFetch>[1],
): Promise<PhoneTeamSettingsResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedPhoneConfigurationFetch<PhoneTeamSettingsResponseOutput>(
    getSaveTeamPhoneSettingsUrl(teamId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(phoneTeamSettingsBody),
      schema: PhoneTeamSettingsResponseOutput,
    },
  );
};

export const getSaveTeamPhoneSettingsMutationKey = () => ['saveTeamPhoneSettings'] as const;

export const getSaveTeamPhoneSettingsMutationOptions = <
  TError = PhoneErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveTeamPhoneSettings>>,
    TError,
    SaveTeamPhoneSettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveTeamPhoneSettings>>,
  TError,
  SaveTeamPhoneSettingsMutationVariables,
  TContext
> => {
  const mutationKey = getSaveTeamPhoneSettingsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveTeamPhoneSettings>>,
    SaveTeamPhoneSettingsMutationVariables
  > = (props) => {
    const { teamId, data } = props ?? {};

    return saveTeamPhoneSettings(teamId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveTeamPhoneSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveTeamPhoneSettings>>
>;
export type SaveTeamPhoneSettingsMutationBody = PhoneTeamSettingsBody;
export type SaveTeamPhoneSettingsMutationError = PhoneErrorResponse;
export type SaveTeamPhoneSettingsMutationVariables = {
  teamId: string;
  data: PhoneTeamSettingsBody;
};

export const useSaveTeamPhoneSettings = <
  TError = PhoneErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveTeamPhoneSettings>>,
    TError,
    SaveTeamPhoneSettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveTeamPhoneSettings>>,
  TError,
  SaveTeamPhoneSettingsMutationVariables,
  TContext
> => {
  return useMutation(getSaveTeamPhoneSettingsMutationOptions(options));
};
export const getGetTeamPhoneNumberUrl = (teamId: string) => {
  return `/api/v1/teams/${teamId}/phone-number`;
};

export const getTeamPhoneNumber = async (
  teamId: string,
  options?: Parameters<typeof validatedPhoneConfigurationFetch>[1],
): Promise<PhoneTeamNumberResponseOutput> => {
  return validatedPhoneConfigurationFetch<PhoneTeamNumberResponseOutput>(
    getGetTeamPhoneNumberUrl(teamId),
    {
      ...options,
      method: 'GET',

      schema: PhoneTeamNumberResponseOutput,
    },
  );
};

export const getGetTeamPhoneNumberQueryKey = (teamId: string) => {
  return [`/api/v1/teams/${teamId}/phone-number`] as const;
};

export const getGetTeamPhoneNumberQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamPhoneNumber>>,
  TError = PhoneErrorResponse,
>(
  teamId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTeamPhoneNumber>>, TError, TData>;
    request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamPhoneNumberQueryKey(teamId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamPhoneNumber>>> = ({ signal }) =>
    getTeamPhoneNumber(teamId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: teamId !== null && teamId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTeamPhoneNumber>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetTeamPhoneNumberQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamPhoneNumber>>
>;
export type GetTeamPhoneNumberQueryError = PhoneErrorResponse;

export function useGetTeamPhoneNumber<
  TData = Awaited<ReturnType<typeof getTeamPhoneNumber>>,
  TError = PhoneErrorResponse,
>(
  teamId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getTeamPhoneNumber>>, TError, TData>;
    request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTeamPhoneNumberQueryOptions(teamId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCustomerPhoneSettingsUrl = (customerId: string) => {
  return `/api/v1/customers/${customerId}/phone-settings`;
};

export const getCustomerPhoneSettings = async (
  customerId: string,
  options?: Parameters<typeof validatedPhoneConfigurationFetch>[1],
): Promise<PhoneCustomerSettingsResponseOutput> => {
  return validatedPhoneConfigurationFetch<PhoneCustomerSettingsResponseOutput>(
    getGetCustomerPhoneSettingsUrl(customerId),
    {
      ...options,
      method: 'GET',

      schema: PhoneCustomerSettingsResponseOutput,
    },
  );
};

export const getGetCustomerPhoneSettingsQueryKey = (customerId: string) => {
  return [`/api/v1/customers/${customerId}/phone-settings`] as const;
};

export const getGetCustomerPhoneSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerPhoneSettings>>,
  TError = PhoneErrorResponse,
>(
  customerId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCustomerPhoneSettings>>, TError, TData>;
    request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomerPhoneSettingsQueryKey(customerId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerPhoneSettings>>> = ({
    signal,
  }) => getCustomerPhoneSettings(customerId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: customerId !== null && customerId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCustomerPhoneSettings>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetCustomerPhoneSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerPhoneSettings>>
>;
export type GetCustomerPhoneSettingsQueryError = PhoneErrorResponse;

export function useGetCustomerPhoneSettings<
  TData = Awaited<ReturnType<typeof getCustomerPhoneSettings>>,
  TError = PhoneErrorResponse,
>(
  customerId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCustomerPhoneSettings>>, TError, TData>;
    request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomerPhoneSettingsQueryOptions(customerId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSaveCustomerPhoneSettingsUrl = (customerId: string) => {
  return `/api/v1/customers/${customerId}/phone-settings`;
};

export const saveCustomerPhoneSettings = async (
  customerId: string,
  phoneCustomerSettingsBody: PhoneCustomerSettingsBody,
  options?: Parameters<typeof validatedPhoneConfigurationFetch>[1],
): Promise<PhoneCustomerSettingsResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedPhoneConfigurationFetch<PhoneCustomerSettingsResponseOutput>(
    getSaveCustomerPhoneSettingsUrl(customerId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(phoneCustomerSettingsBody),
      schema: PhoneCustomerSettingsResponseOutput,
    },
  );
};

export const getSaveCustomerPhoneSettingsMutationKey = () => ['saveCustomerPhoneSettings'] as const;

export const getSaveCustomerPhoneSettingsMutationOptions = <
  TError = PhoneErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCustomerPhoneSettings>>,
    TError,
    SaveCustomerPhoneSettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveCustomerPhoneSettings>>,
  TError,
  SaveCustomerPhoneSettingsMutationVariables,
  TContext
> => {
  const mutationKey = getSaveCustomerPhoneSettingsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveCustomerPhoneSettings>>,
    SaveCustomerPhoneSettingsMutationVariables
  > = (props) => {
    const { customerId, data } = props ?? {};

    return saveCustomerPhoneSettings(customerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveCustomerPhoneSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveCustomerPhoneSettings>>
>;
export type SaveCustomerPhoneSettingsMutationBody = PhoneCustomerSettingsBody;
export type SaveCustomerPhoneSettingsMutationError = PhoneErrorResponse;
export type SaveCustomerPhoneSettingsMutationVariables = {
  customerId: string;
  data: PhoneCustomerSettingsBody;
};

export const useSaveCustomerPhoneSettings = <
  TError = PhoneErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCustomerPhoneSettings>>,
    TError,
    SaveCustomerPhoneSettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveCustomerPhoneSettings>>,
  TError,
  SaveCustomerPhoneSettingsMutationVariables,
  TContext
> => {
  return useMutation(getSaveCustomerPhoneSettingsMutationOptions(options));
};
export const getUploadPhonePromptAssetUrl = (params: UploadPhonePromptAssetParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/phone/prompt-assets?${stringifiedParams}`
    : `/api/v1/phone/prompt-assets`;
};

export const uploadPhonePromptAsset = async (
  uploadPhonePromptAssetBody: Blob,
  params: UploadPhonePromptAssetParams,
  options?: Parameters<typeof validatedPhoneConfigurationFetch>[1],
): Promise<PhonePromptAssetMetadataResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedPhoneConfigurationFetch<PhonePromptAssetMetadataResponseOutput>(
    getUploadPhonePromptAssetUrl(params),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'audio/mpeg', ...getHeaders(options?.headers) },
      body: uploadPhonePromptAssetBody,
      schema: PhonePromptAssetMetadataResponseOutput,
    },
  );
};

export const getUploadPhonePromptAssetMutationKey = () => ['uploadPhonePromptAsset'] as const;

export const getUploadPhonePromptAssetMutationOptions = <
  TError = PhoneErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPhonePromptAsset>>,
    TError,
    UploadPhonePromptAssetMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadPhonePromptAsset>>,
  TError,
  UploadPhonePromptAssetMutationVariables,
  TContext
> => {
  const mutationKey = getUploadPhonePromptAssetMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadPhonePromptAsset>>,
    UploadPhonePromptAssetMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return uploadPhonePromptAsset(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadPhonePromptAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadPhonePromptAsset>>
>;
export type UploadPhonePromptAssetMutationBody = Blob;
export type UploadPhonePromptAssetMutationError = PhoneErrorResponse;
export type UploadPhonePromptAssetMutationVariables = {
  data: Blob;
  params: UploadPhonePromptAssetParams;
};

export const useUploadPhonePromptAsset = <
  TError = PhoneErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPhonePromptAsset>>,
    TError,
    UploadPhonePromptAssetMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedPhoneConfigurationFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadPhonePromptAsset>>,
  TError,
  UploadPhonePromptAssetMutationVariables,
  TContext
> => {
  return useMutation(getUploadPhonePromptAssetMutationOptions(options));
};
export const getPreviewPhonePromptAssetUrl = (assetId: string) => {
  return `/api/v1/phone/prompt-assets/${assetId}`;
};

export const previewPhonePromptAsset = async (
  assetId: string,
  options?: Parameters<typeof validatedPhonePromptPreviewFetch>[1],
): Promise<Blob> => {
  return validatedPhonePromptPreviewFetch<Blob>(getPreviewPhonePromptAssetUrl(assetId), {
    ...options,
    method: 'GET',
  });
};

export const getPreviewPhonePromptAssetQueryKey = (assetId: string) => {
  return [`/api/v1/phone/prompt-assets/${assetId}`] as const;
};

export const getPreviewPhonePromptAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof previewPhonePromptAsset>>,
  TError = PhoneErrorResponse,
>(
  assetId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof previewPhonePromptAsset>>, TError, TData>;
    request?: SecondParameter<typeof validatedPhonePromptPreviewFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPreviewPhonePromptAssetQueryKey(assetId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof previewPhonePromptAsset>>> = ({
    signal,
  }) => previewPhonePromptAsset(assetId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: assetId !== null && assetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof previewPhonePromptAsset>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type PreviewPhonePromptAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewPhonePromptAsset>>
>;
export type PreviewPhonePromptAssetQueryError = PhoneErrorResponse;

export function usePreviewPhonePromptAsset<
  TData = Awaited<ReturnType<typeof previewPhonePromptAsset>>,
  TError = PhoneErrorResponse,
>(
  assetId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof previewPhonePromptAsset>>, TError, TData>;
    request?: SecondParameter<typeof validatedPhonePromptPreviewFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPreviewPhonePromptAssetQueryOptions(assetId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}
